import React, { useState ,useEffect} from "react";
import "./envelope.css";

import TopFlap from "./Topflap";
import BottomFlap from "./BottomFlap";
import LeftFlap from "./LeftFlap";
import RightFlap from "./RightFlap";
import { NavLink } from 'react-router-dom'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { ReactComponent as GanpatiIcon } from "../../../../../images/ganpati2.svg";
import { ReactComponent as OmIcon } from '../../../../../images/om.svg';
import { ReactComponent as EkOnkarIcon } from '../../../../../images/ekonkar.svg';
import { ReactComponent as KhandaIcon } from '../../../../../images/khanda.svg';
import { ReactComponent as CrossIcon } from '../../../../../images/cross.svg';
import { ReactComponent as BismillahIcon } from '../../../../../images/bismillah.svg';
import { ReactComponent as WaipIcon } from '../../../../../images/waip.svg';
import { ReactComponent as RingsIcon } from '../../../../../images/rings.svg';
import { ReactComponent as KnotIcon } from '../../../../../images/knot.svg';
import { ReactComponent as SwastikIcon } from '../../../../../images/swastik.svg';
import { ReactComponent as BuddhaIcon } from '../../../../../images/buddha.svg';
const Envelope = ({ SetEnvelopeScreen,details ,demoExpired,onOpen,iconAnimate}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [greetingIndex, setGreetingIndex] = useState(0);

  const religiousGreetings = [
  {
    id: "ganpati",
    Icon: GanpatiIcon,
    text: "श्री गणेशाय नमः",
  },
  {
    id: "ek-onkar",
    Icon: EkOnkarIcon,
    text: "ੴ ਸਤਿਗੁਰ ਪ੍ਰਸਾਦਿ",
  },
  {
    id: "bismillah",
    Icon: BismillahIcon,
    text: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  },
  {
    id: "christian",
    Icon: CrossIcon,
    text: "With God's Blessings",
  },
];

useEffect(() => {
  // Keep the original cover content for normal invitations.
  if (!iconAnimate) {
    setGreetingIndex(0);
    return;
  }

  // Change the icon and greeting periodically in sample previews.
  const interval = setInterval(() => {
    setGreetingIndex((previousIndex) =>
      (previousIndex + 1) % religiousGreetings.length
    );
  }, 1000);

  return () => clearInterval(interval);
}, [iconAnimate]);

  const handleSealClick = () => {
    if (isAnimating) return;

    setIsAnimating(true);

      if (onOpen) {
    onOpen();
  }
  

    setTimeout(() => {
      setIsVisible(false);
      SetEnvelopeScreen(false)
    }, 1350);
  };

  if (!isVisible) return null;

  const iconMapping = {
      EkOnkarIcon,
      GanpatiIcon,
      OmIcon,
      KhandaIcon,
      CrossIcon,
      BismillahIcon,
      WaipIcon,
      RingsIcon,
      KnotIcon,
      SwastikIcon,
      BuddhaIcon,
  };


//    const stampImage = {
//   theme1:
//     "/stamp.png",

//   theme2:
//     "/theme2-stamp.png",

//   theme3:
//     "/theme3-stamp.png",

//   theme4:
//     "/theme-4-stamp.png",

//     theme5:
//     '/theme3-stamp.png'
// };

 const stampImage = {
  theme1:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1792805549/aamantran%20assets/stamp_fzb6qr.png",

  theme2:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1792806588/aamantran%20assets/theme2-stamp_e6ab55.png",

  // Add more themes here
  theme3:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1792806687/aamantran%20assets/theme3-stamp_ttujeb.png",

  theme4:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1792806745/aamantran%20assets/theme-4-stamp_rkprpw.png",

    theme5:
    'https://res.cloudinary.com/depixc8dq/image/upload/v1792806687/aamantran%20assets/theme3-stamp_ttujeb.png'
};

const defaultStamp =
  "/stamp.png";

    const SealImage =
    stampImage[details?.theme] || defaultStamp;


     const getOptimizedStampUrl = (url, width) =>
  url.replace("/upload/", `/upload/f_auto,q_auto,w_${width}/`);

const isCloudinaryStamp = SealImage.includes("res.cloudinary.com");

const stampSrcSet = isCloudinaryStamp
  ? `
      ${getOptimizedStampUrl(SealImage, 160)} 160w,
      ${getOptimizedStampUrl(SealImage, 200)} 200w,
      ${getOptimizedStampUrl(SealImage, 320)} 320w,
      ${getOptimizedStampUrl(SealImage, 450)} 450w
    `
  : undefined;

const stampSrc = isCloudinaryStamp
  ? getOptimizedStampUrl(SealImage, 200)
  : SealImage;
  

 const Icon = ({ className }) => {
        const Component = iconMapping[details && details.coverIcon];

        if (!Component) return null;

        return <Component className={className} />;
    };

  return (
    <>
    <div className={`envelope-screen ${details?.theme || ''}`}>

      <div className={`envelope ${isAnimating ? "animate" : ""}`}>
       <div className="envelope-seal">
        {/* <img
          src={SealImage}
          alt="Seal"
          onClick={handleSealClick}
        /> */}
          <img
  src={stampSrc}
  srcSet={stampSrcSet}
  sizes="(min-width: 1000px) 150px, (min-width: 767px) 140px, (min-width: 424px) 200px, 160px"
  alt="Seal"
  onClick={handleSealClick}
/>
        </div>
         {/* <div className="top-area">
            <div className="top-area-content">
             <Icon className="top-area-icon" />
          <span>{details && details.coverText}</span>
        </div>
         </div> */}
       <div className="top-area">
      <div
  className={`top-area-content ${
    iconAnimate ? "top-area-content-animated" : ""
  }`}
>
  {iconAnimate ? (
    <div
      key={religiousGreetings[greetingIndex].id}
      className="religious-greeting"
    >
      {React.createElement(
        religiousGreetings[greetingIndex].Icon,
        { className: "top-area-icon" }
      )}

      <span>
        {religiousGreetings[greetingIndex].text}
      </span>
    </div>
  ) : (
    <>
      <Icon className="top-area-icon" />
      <span>{details && details.coverText}</span>
    </>
  )}

</div>
</div>
<div className="click-to-open">
  Click to open
</div>

<div className="bottom-area-content">

  <span className="bottom-title">
    {details && details.withRegardsTitle}
  </span>

  <span className="bottom-name">
 {["q8ts9r1c0", "lkbzt93ja"].includes(details?.userCode) ? (
    <b>{details && details.withRegards}</b>
  ) : (
    details && details.withRegards
  )}
  </span>

</div>
        <TopFlap />
        <BottomFlap />
        <LeftFlap />
        <RightFlap />

      </div>

    </div>
   {demoExpired && (
             <div className="demo-expired-modal-overlay">
                 <div className="demo-expired-modal" >
                    <h2>
                 <span role="img" aria-label="lock">🔒</span> Invite Access Paused
   
               </h2>
                 <p className="demo-expired-subtext-1">This invite is currently locked. Please ask the host to unlock it.</p>
                  {/* <p className="demo-expired-subtext-2">( Hurry Up! Invite Expires Soon )</p> */}
                   <NavLink to="/" className="demo-expired-btn">
                             Unlock Invite <ArrowForwardIcon style={{marginLeft:"5px",transform: "translateY(-1px)" }}/>
                           </NavLink>
                 </div>
             </div>
   )}
    </>
  );
};

export default Envelope;